((document, Drupal) => {
  "use strict";

  Drupal.behaviors.wysiwyg = {
    attach: function (context) {
      const tables = document.querySelectorAll(".wysiwyg table");
      const wrapTable = (table) => {
        table.outerHTML = `<div class='table__outer'>${table.outerHTML}</div>`;
      };
      if (tables !== null) {
        tables.forEach((table) => {
          wrapTable(table);
        });
      }
    },
  };
})(document, Drupal);
